import { apiClient } from "@/core/api/ApiClient";
import { ChargeDto, EntityType } from "@/core/api/generated/v1";

import BaseEntitiesDeleteModal, {
  BaseEntitiesDeleteModalInheritableProps,
} from "../components/BaseEntitiesDeleteModal";

export interface OwnProps {
  entities: ChargeDto[];
}

type Props = OwnProps & BaseEntitiesDeleteModalInheritableProps;

export default function ChargesDeleteModal({ entities, ...otherProps }: Props) {
  return (
    <BaseEntitiesDeleteModal
      cascadeActionDisplay={false}
      entityType={EntityType.Charge}
      entities={entities}
      deleteFunc={async (params) => {
        await apiClient.chargesApi.apiV1ChargesBulkDeleteDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          entityBulkDeleteDto: {
            ids: params.entityIds,
            relatedEntitiesTypes: params.relatedEntitiesTypes,
          },
        });
      }}
      {...otherProps}
    />
  );
}
